import { render, staticRenderFns } from "./SuperkidLanding.vue?vue&type=template&id=c77d65ea&scoped=true&"
import script from "./SuperkidLanding.vue?vue&type=script&lang=js&"
export * from "./SuperkidLanding.vue?vue&type=script&lang=js&"
import style0 from "./SuperkidLanding.vue?vue&type=style&index=0&id=c77d65ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77d65ea",
  null
  
)

export default component.exports